import NewBankAccount from './NewBankAccount'
import Subject from './Subject'
import CurrencySelect from './CurrencySelect'
import Payment from './Payment'

export default class BankAccount {
  constructor(component) {
    this.component = component
  }
  name() {
    return 'bank-account'
  }
  handle(event) {
    if(event.back) {
      this.component.modalExpanded = false
      switch(this.component.selected_operation) {
        case 'charge':
        case 'pay':
        case 'receive':
          this.component.transaction_controller = new Subject(this.component)
          break
        case 'withdrawal_internal':
          this.component.transaction_controller = new CurrencySelect(this.component)
          break
      }
      return
    }
    if(event.newBankAccount) {
      this.component.modalExpanded = true
      this.component.transaction_controller = new NewBankAccount(this.component)
      return
    }
    if(event.selectedBankAccount) {
      this.component.selected_bank_account = event.selectedBankAccount
      this.component.modalExpanded = false
      this.component.transaction_controller = new Payment(this.component)
      return
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/BankAccount.js